import Mock from 'mockjs'

/*
* url = '/api/test/list'
* data|20 = 生成20条数据
* */
Mock.mock('/api/test/list', 'get', {
  'data|20': [{
    'id': '@natural',  // id 自增，从 0 开始
    'lastId': '@natural',
    'num':'@integer( 1, 200 )',
    'price':'1000.00',
    'email': '@email',  // 随机生成邮箱地址
    'boolean': '@boolean',  // 随机生成布尔值
    'datetime': '@datetime',  // 随机生成日期时间
    'image': '@image(\'200x200\')',  // 随机生成图片大小为 200x200 的图片链接
    'text': '@csentence(30)',  // 随机生成 30 个中文字符
    'title|1': ['预存款','账期支付'],  
    'name': '@cname',  // 随机生成中文名字
    'web': '@domain',  // 随机生成域名
    'address': '@county(true)',  // 随机生成所属的省、市、县
  }]
});
Mock.mock('/api/test/details','get',{
  'data|20':[{
    'id':'@natural',
    'lastId': '@natural',
    'name': '@cname',  // 随机生成中文名字
    'title|1': ['预存款','账期支付'],  
    'num':'@integer( 1, 200 )',
    'price':'1000.00',
    'state|1':['待支付','待发货','待确认','已发货','交易完成','交易关闭'],
    'datetime': '@datetime',  // 随机生成日期时间
  }]
});
Mock.mock('/api/test/outofstock','get',{
  'data|20':[{
    'id':'@natural',
    'lastId': '@natural',
    'name': '@cname',  // 随机生成中文名字
    'mobile':/^1[0-9]{10}$/ ,
    'datetime': '@datetime',  // 随机生成日期时间
  }]
});
Mock.mock('/api/test/processing','get',{
  'data|20':[{
    'id':'@natural',
    'BuyersName': '@cname',  // 随机生成中文名字
    'name': '@cname',  // 随机生成中文名字
    'mobile':/^1[0-9]{10}$/ ,
    'num0':'@integer( 1, 300 )',
    'num1':'@integer( 1, 200 )',
    'num2':'@integer( 1, 100 )',
    'num3':'@integer( 1, 100 )',
    'state|1':['未发货','部分发货','已发货'],
    'datetime': '@datetime',  // 随机生成日期时间
  }]
});
Mock.mock('/api/test/processing/sku','get',{
  'data|20':[{
    'text': '@csentence(20)',  // 随机生成 30 个中文字符
    'id':'@natural',
    'lastId': '@natural',
    'num0':'@integer( 1, 300 )',
    'num1':'@integer( 1, 200 )',
  }]
});
Mock.mock('/api/test/send_out','get',{
  'data|20':[{
    'id':'@natural',
    'lastId': '@natural',
    'name': '@cname',  // 随机生成中文名字
    'mobile':/^1[0-9]{10}$/ ,
    'outId': '@natural',
    'state|1':['待发货','已发货'],
    'BuyersName': '@cname',  // 随机生成中文名字
    'datetime': '@datetime',  // 随机生成日期时间
  }]
});